<i18n>
	{
		"en": {
			"welcome": "Welcome"
		},
		"fr": {
			"welcome": "Bienvenue"
		}
	}
</i18n>

<template>

	<b-navbar toggleable="md" type="dark" variant="secondary" fixed='top'>

		<b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

		<b-navbar-brand><img src="../assets/epfllogo.png" style="margin-right:5px; height: 40px"></b-navbar-brand>
		<h2><router-link to="/" style = 'font-size: 1.5rem;' class = 'navbar-brand'>{{siteTitle}}</router-link></h2>
	
		<b-collapse is-nav id="nav_collapse">

			<!-- Right aligned nav items -->
			<b-navbar-nav class="ml-auto">

				<b-navbar-nav right>
					<gene-search v-access = '"active"' from="nav"></gene-search>
					<b-nav-item v-access = '"active"'><router-link class="navbar_link" to="/gene">Genes</router-link></b-nav-item>
					<b-nav-item v-access = '"active"'><router-link class="navbar_link" to="/lists">Lists</router-link></b-nav-item>
					<b-nav-item v-access = '"active"'><router-link class="navbar_link" to="/datasets">Datasets</router-link></b-nav-item>
					<b-nav-item v-access = '"admin"'><router-link to="/admin">Admin</router-link></b-nav-item>
					<b-nav-item class="nowrap nocursor" v-access = '"active"'>Welcome {{user.username}}</b-nav-item>
					<b-nav-item v-access = '"active"'><router-link to="/login"><v-icon name = 'sign-out-alt'></v-icon></router-link></b-nav-item>
				</b-navbar-nav>
			</b-navbar-nav>

		</b-collapse>
	</b-navbar>
	<!-- <b-navbar toggleable="md" type="light" variant="light" fixed='top'>

	<b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

	<b-navbar-brand href="#"><img src="../assets/sib_logo_small.gif" style="margin-right:5px"><router-link to="/" style = 'font-size: 1.3rem;'>{{siteTitle}}</router-link></b-navbar-brand>

	<b-collapse is-nav id="nav_collapse">


	<b-navbar-nav class="ml-auto">

	<b-navbar-nav right>
	<b-nav-item v-access = '"admin"'><router-link to="/admin">Admin</router-link></b-nav-item>
	<b-nav-item v-access = '"active"'>{{$t('welcome')}} {{user.fullname}}</b-nav-item>
	<b-nav-item v-access = '"active"'><router-link to="/login"><v-icon name = 'sign-out-alt'></v-icon></router-link></b-nav-item>
	<b-nav-item-dropdown :text="'Lang: '+lang" right v-if='multilang'>
	<b-dropdown-item @click="changeLang('en')">EN</b-dropdown-item>
	<b-dropdown-item @click="changeLang('fr')">FR</b-dropdown-item>
</b-nav-item-dropdown>
</b-navbar-nav>

</b-navbar-nav>

</b-collapse>
</b-navbar> -->

</template>
<script>

import { mapGetters } from 'vuex'
import { multilang, siteTitle } from '@/app_config'
import geneSearch from '@/components/geneSearch'

export default {
	name: 'navHeader',
	components:{geneSearch},
	data () {
		return {
			multilang: multilang,
			siteTitle: siteTitle
		}
	},
	computed: {
		...mapGetters({
			user: 'currentUser'
		}),
		lang () {
			return this.$i18n.locale
		},
		currentProject () {
			return this.user.projects.filter(p => p.project_id == this.user.project_id)[0];
		}
	},
	methods: {
		setProject (project){
			this.$store.dispatch('setProject',project).then(() => {
				this.$router.go();
			});
		},
		changeLang (value) {
			this.$root.$i18n.locale = value
		}
	}

}

</script>

<style>
	b-navbar-nav > a{
		color:white;
	}
</style>